import { render, staticRenderFns } from "./NewWarehouseDocumentInvoicePage.vue?vue&type=template&id=2cf53ce5&scoped=true"
import script from "./NewWarehouseDocumentInvoicePage.vue?vue&type=script&lang=js"
export * from "./NewWarehouseDocumentInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf53ce5",
  null
  
)

export default component.exports